import React, { FC } from 'react'
import { ClassNameValue } from 'tailwind-merge'
import cn from '../../lib/utils/cn'

export interface SwitcherOption {
	label: string
	value: string | number
	color?: string
}

interface SwitcherProps {
	options: SwitcherOption[]
	value: string | number
	onChange: (value: string | number) => void
	className?: ClassNameValue
	classNameItem?: ClassNameValue
	disabled?: boolean
	withColorLabels?: boolean
}

const Switcher: FC<SwitcherProps> = ({
	options,
	value,
	onChange,
	className,
	classNameItem,
	disabled = false,
	withColorLabels = false,
}) => (
	<div
		className={cn(
			'flex items-center justify-center rounded-lg overflow-hidden h-9',
			className
		)}
	>
		{options.map((option, index) => {
			const isFirst = index === 0
			const isLast = index === options.length - 1
			const isSelected = value === option.value

			return (
				<button
					key={option.value}
					onClick={() => onChange(option.value)}
					className={cn(
						'w-fit px-4 h-full disabled:opacity-50 flex items-center justify-center gap-1.5 box-border',
						isFirst ? 'rounded-l-lg' : 'border-l-0',
						isLast ? 'rounded-r-lg' : 'border-r-0',
						isSelected
							? 'text-white bg-text-main dark:bg-text-main-dark dark:text-text-main'
							: 'bg-white dark:bg-background-dark text-text-main dark:text-text-main-dark border border-stroke-light dark:border-stroke-light-dark hover:bg-background-light transition-colors duration-200 ease-in-out',
						classNameItem
					)}
					disabled={disabled}
				>
					{withColorLabels && option.color && (
						<div
							className="h-4 w-0.5 rounded-full"
							style={{ backgroundColor: option.color }}
						/>
					)}
					{option.label}
				</button>
			)
		})}
	</div>
)

export default Switcher
